const SelectionBox = ({
    title,
    options = [],
    value,
    useAll = true,
    onChange = () => {},
    onKeyDown = () => {},
    size,
    w140 = false,
    disabled = false,
}) => {
    return (
        <div
            className={
                'form-box ' +
                (size != undefined ? (size == 'small' ? ' w-sm' : size == 'medium' ? ' w-md' : ' w-lg') : '') +
                (w140 ? ' w-140' : '')
            }
        >
            <div className='input-box input-box-select'>
                <label htmlFor={title}>{title}</label>
                <div className='input-group'>
                    <select
                        id={title}
                        className={'form-control form-sel '}
                        // className={'form-control form-sel ' + (w140 ? 'w-140' : '')}
                        disabled={disabled}
                        value={value || undefined}
                        onChange={(e) => onChange(e)}
                        onKeyDown={(e) => onKeyDown(e)}
                    >
                        {useAll && (
                            <option key='ALL' value=''>
                                전체
                            </option>
                        )}
                        {options.map((option, index) => (
                            <option key={index} value={option.cd}>
                                {option.cdNm}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );
};

export default SelectionBox;
